import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface NoticeDetialRequest {
    category: string;
    list_no: string;
}

export interface NoticesDetailResponse {
    // statusCode: number;
    // message: string;
    // data: {
    flag: boolean;
    list_no: number;
    subject: string;
    contents: string;
    w_date: string;
    b_file: string;
    notice: number;
    // };
}

export const useGetConsoleNoticeDetail = ({ category, list_no }: NoticeDetialRequest): UseQueryResult<NoticesDetailResponse, Error> => {
    let url = enum_api_uri.get_console_notice_detail.replace(":category", category).replace(":list_no", list_no);
    return useQuery({
        queryKey: ["useGetConsoleNoticeDetail", category, list_no],
        queryFn: async () => {
            const response = await axiosInstance.get(
                url,
                //     {
                //     params: {
                //         category,
                //         list_no,
                //     },
                // }
            );
            return response.data.data;
        },
        enabled: !!category && !!list_no,
    });
};
